module.exports = __webpack_public_path__ + "static/media/ic_info.b3752a38.svg";